import { AfterViewChecked, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
//import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
//import { ImageCroppedEvent} from 'ngx-image-cropper';

import { MessageService, ConfirmationService, TreeNode } from "primeng/api";

import { TranslateConfigService } from 'src/app/core/services/translate-config.service';
import { ScUserDetailOutput, ScUserOutput } from '../../../models/response/sc-user.model';
import { DropDown, GenericFeedback } from 'src/app/shared/model/base-model';
import { ScUserService } from '../../../core/services/sc/sc-user.service';
import { UserTokenService } from 'src/app/core/services/user-token.service';
import { ScCompanyService } from '../../../pages/sc-company/sc-company.service';
import { ScRoleService } from '../../../pages/sc-role/sc-role.service';
import { SfMessageService } from 'src/app/core/services/core/sf-message.service';
import { BreadCrumb } from 'src/app/shared/components/sf-breadcrumb/sf-breadcrumb.model';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { passwordMatchValidator } from 'src/app/shared/validators/passwordMatchValidator';
import { Subscription } from 'rxjs';


// class ImageSnippet {
//     constructor(public src: string, public file: File) {}
// }

@Component({
    selector: 'sc-user-detail',
    templateUrl: './sc-user-detail.component.html',
    styleUrls: ['./sc-user-detail.component.scss'],
    providers: [ConfirmationService, MessageService]
})
export class ScUserDetailComponent implements OnInit, OnChanges, AfterViewChecked, OnDestroy {


    @Input() id: string;
    @Output() chosedItem = new EventEmitter();

    public receivedData: any;
    public receivedAction: string;
    public feedbackData: GenericFeedback = {};

    public item: ScUserOutput = {};
    public itemTemp: ScUserOutput = {};
    public userId: string = null;
    public language: string = "pt-BR";
    public origin: string = "ScUserDetailComponent";

    public treeItem: TreeNode;
    public roleItem: DropDown;
    public userSignForList: DropDown[] = [];
    public selectedSkills: DropDown[] = [];

    public detailItem: ScUserDetailOutput = {};
    public BREAD_CRUMB_LIST: Array<BreadCrumb> = [];
    public headerTitle: string = "";
    public headerDescription: string = "";




    //access
    public hasClerk: boolean = true;
    public canChangeLogin: boolean = true;
    public canUpdate: boolean = true;
    public canUpdateEmail: boolean = false;
    public hasPicture: boolean = false;
    public invalidEmail: boolean = false;
    public isMyData: boolean = false;
    public isLoaded: boolean = false;
    public isNew: boolean = false;




    public message: string = "";
    public pageMessage: string = "";
    public errorMessage: string = "";
    public msgPrefix: string = '';
    public classBtnUpd: string = "p-button p-button-success p-m-1 mr-1";
    public classBtnDel: string = "p-button p-button-danger p-m-1 mr-1";
    public classBtnReset: string = "p-button p-button-warning p-m-1 mr-1";






    // public userPicDialog: boolean = false;
    // public imageChangedEvent: any = '';
    // public croppedImage: any;
    // public showCropper = false;
    // public fileList: any[] = [];
    // public imageBlob: any;
    // public imageUrl: string;

    dialogPwdUpdate: boolean = false;
    passwordForm: FormGroup;
    isAdmin: boolean = false;
    subscription!: Subscription;

    constructor(private userTokenService: UserTokenService,
        private userService: ScUserService,
        private roleService: ScRoleService,
        private companyService: ScCompanyService,
        private confirmationService: ConfirmationService,
        private messageService: SfMessageService,
        private translateService: TranslateService,
        private translateConfigService: TranslateConfigService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private notificationsService: NotificationsService,
        private fb: FormBuilder
    ) { }

    ngOnInit(): void {

        this.activatedRoute.paramMap.subscribe(params => {
            this.id = params.get('id');
            if (this.id && this.id != "new") {
                this.isMyData = false;
                this.getItem();
            }
        });
        if (this.id == null || this.id == undefined || this.id == "") {
            this.id = this.userId;
            this.isMyData = true;
        }
        else {
            this.isMyData = false;
            if (this.id != "new")
                this.isNew = true;
        }

        this.translate();
        this.isAdmin = this.userTokenService.hasPermissionArray(['SF_ADMIN', 'SF_SELLER', 'ROLE_ADMIN', 'ROLE_MANAGER']);
        this.canUpdate = this.userTokenService.hasPermissionArray(['SF_ADMIN', 'SF_SELLER', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SERVICE']);
        this.canChangeLogin = this.companyService.canChangeLogin(this.userTokenService.getCompanyId());
        this.hasClerk = this.userTokenService.getCompanyConfig('CLERK');
        this.userId = this.userTokenService.getUserId();

        if (this.canUpdate == false)
            this.classBtnDel = this.classBtnReset = "p-button p-button-secondary p-m-1 mr-1";

        if (this.canUpdate && this.id == "new") {
            this.canUpdateEmail = true;
        }

        // else{
        //     this.item.isActive = true;
        //     this.item.isBlocked = false;
        //     this.item.isEmailConfirmed = true;
        //     this.item.isFirstAccess = true;
        //     this.item.languageCode = this.language;
        // }
        this.getUserData();





    }

    ngOnChanges(): void {

        this.feedbackAction();
        // if (this.receivedAction == "save")
        //     this.saveItem();
    }

    ngAfterViewChecked(): void {
        this.userService.isUserFormValid.emit(this.isFieldValid('all'));
    }

    ngOnDestroy(): void {
        if (this.subscription !== undefined && this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    getUserData() {
        this.userService.dataChanged.subscribe((data: any) => {
            this.receivedData = data;

            if (this.receivedData == null || this.receivedData == "" || this.receivedData === undefined) {
                this.item.isActive = true;
                this.item.isBlocked = false;
                this.item.isEmailConfirmed = true;
                this.item.isFirstAccess = true;
                this.item.languageCode = this.language;
                this.isNew = true;
            }
            else {
                this.item = this.receivedData;
                this.itemTemp = { ...this.receivedData };
            }
            this.userService.isUserFormValid.emit(this.isFieldValid('all'));


            this.isLoaded = true;
        });

    }

    feedbackAction() {
        this.subscription = this.userService.actionChanged.subscribe((data: any) => {
            this.receivedAction = data;
            this.saveItem();

        });
    }



    getItem() {
        this.userService.getItem(this.id).subscribe(
            {
                next: (res) => {
                    if (res) {
                        this.item = res.data;
                        this.itemTemp = { ...res.data };
                        if (this.item != null) {
                            this.hasPicture = !(this.item.pictureUri == undefined || this.item.pictureUri == null || this.item.pictureUri == "");
                            //this.getItemDetail();
                            this.userService.isUserFormValid.emit(this.isFieldValid('all'));
                        }
                    }
                    this.translate();
                },
                error: (err) => console.log(`UserDetail - getItem : ${err}.`)
            });
    }

    // getUserPersonalData() {
    //     this.isMyData = true;
    //     this.userService.getUserPersonalData().subscribe(
    //     {
    //     next: (res) => {
    //         if (res)
    //         {
    //             this.item = res.data;
    //             if (this.item != null){
    //                 this.hasPicture = !(this.item.pictureUri == undefined || this.item.pictureUri == null || this.item.pictureUri == "");
    //                 //this.getItemDetail();

    //             }
    //         }
    //         this.translate();
    //     },
    //     error: (err) => console.log(`UserDetail - getItem : ${err}.`)
    //     });
    // }

    //TODO USER DETAIL => SKILLS
    // getItemDetail() {

    //     this.userService.getItemDetail(this.id).subscribe(
    //     {
    //     next: (res) => {
    //         if (res)
    //         {
    //             this.detailItem = res.data;
    //             this.item.scOrganizationStructureId = this.detailItem.scOrganizationStructureId;
    //             this.selectedSkills = this.detailItem.skills;
    //             this.item.skills = this.detailItem.skills;
    //         }
    //     },
    //     error: (err) => console.log(`UserDetail - getItemDetail : ${err}.`)
    //     });
    // }




    // getRole() {
    //     this.roleService.getItemByUserId(this.item.id, this.language).subscribe(
    //     {
    //     next: (res) => {
    //         if (res)
    //             this.item.scRoleId = res.data.id;

    //     },
    //     error: (err) => console.log(`${this.origin} - getRole: ${err}.`)
    //     });
    // }

    saveItem() {
        if (this.item.email.trim()) {
            if (this.item.id) {
                this.item.password = null;
                if (this.isMyData == true) {
                    this.userService
                        .updUserPersonalData(this.item, this.language)
                        .subscribe(
                            {
                                next: () => {
                                    //this.messageService.messageSuccess(this.msgPrefix+this.translateService.instant('message.record_updated'));
                                    this.notificationsService.toastNotify('success', this.translateService.instant('title.success'), this.msgPrefix + this.translateService.instant('message.record_updated'));
                                   // if (this.isAdmin && this.isMyData) {
                                        this.router.navigate(['user']);
                                   // }
                                },
                                error: (err) => {
                                    console.log(`${this.origin} - saveItem - Update : ${err}.`)
                                    this.message = this.translateService.instant('api_response.' + err.error);

                                    if (this.message == "api_response.[object ProgressEvent]" || this.message == "api_response.[object Object]" || this.message == "api_response.null")
                                        this.message = this.translateService.instant('api_response.ERROR');

                                    //this.messageService.messageError(this.msgPrefix+this.translateService.instant(this.message));
                                    this.notificationsService.toastNotify('error', this.translateService.instant('title.warning'), this.message);
                                }
                            });
                }


                else {
                    this.userService
                        .updItem(this.item, null, this.userId, this.language)
                        .subscribe(
                            {
                                next: () => {
                                    //this.messageService.messageSuccess(this.msgPrefix+this.translateService.instant('message.record_updated'));
                                    this.notificationsService.toastNotify('success', this.translateService.instant('title.success'), this.msgPrefix + this.translateService.instant('message.record_updated'));
                                  //  if (this.isMyData) {
                                        this.router.navigate(['user']);
                                   // }
                                },
                                error: (err) => {
                                    console.log(`${this.origin} - saveItem - Update : ${err}.`)
                                    this.message = this.translateService.instant('api_response.' + err.error);

                                    if (this.message == "api_response.[object ProgressEvent]" || this.message == "api_response.[object Object]" || this.message == "api_response.null")
                                        this.message = this.translateService.instant('api_response.ERROR');

                                    //this.messageService.messageError(this.msgPrefix+this.translateService.instant(this.message));
                                    this.notificationsService.toastNotify('error', this.translateService.instant('title.warning'), this.msgPrefix + this.translateService.instant(this.message));
                                }
                            });
                }
            }
            else {
                this.item.isEmailConfirmed = false;
                this.item.isFirstAccess = true;
                this.item.isBlocked = false;
                this.item.isActive = true;
                this.item.isAdmin = false;
                this.item.scOrganizationStructureId = this.userTokenService.getCompanyId();
                this.item.isClient = false;

                this.userService
                    .addItem(this.item, this.userId, this.language)
                    .subscribe({
                        next: () => {
                            //this.messageService.messageSuccess(this.msgPrefix+this.translateService.instant('message.record_updated'));
                            this.notificationsService.toastNotify('success', this.translateService.instant('title.success'), this.msgPrefix + this.translateService.instant('message.record_updated'));
                            this.router.navigate(['user']);
                        },
                        error: (err) => {
                            console.log(`${this.origin} - saveItem - Update : ${err}.`)
                            this.message = this.translateService.instant('api_response.' + err.error);

                            if (this.message == "api_response.[object ProgressEvent]" || this.message == "api_response.[object Object]" || this.message == "api_response.null")
                                this.message = this.translateService.instant('api_response.ERROR');

                            //this.messageService.messageError(this.msgPrefix+this.translateService.instant(this.message));
                            this.notificationsService.toastNotify('error', this.translateService.instant('title.warning'), this.msgPrefix + this.translateService.instant(this.message));

                        }
                    });
            }
        }
    }


    reciverFeedbackRole(event) {
        this.roleItem = event;
        if (this.roleItem != null && this.roleItem.id != undefined) {
            this.item.scRoleId = this.roleItem.id;
        } else {
            this.userService.isUserFormValid.emit(this.isFieldValid('all'));
        }
    }

    reciverFeedbackStructure(event) {
        this.treeItem = event;
        if (this.treeItem != null && this.treeItem.key != undefined && this.treeItem.key != "") {
            this.item.scOrganizationStructureId = this.treeItem.key;
        }
    }

    reciverFeedbackSkill(select: DropDown[]) {
        this.selectedSkills = select;
        this.item.skills = this.selectedSkills;
    }

    reciverFeedbackUserClerk(event) {
        this.item.scUserSignatureId = event;
    }

    // feedback(){
    //     this.chosedItem.emit(this.id)
    // }

    translate() {
        this.language = this.translateConfigService.getLanguage();

        const sleep = (ms) => new Promise(r => setTimeout(r, ms));
        (async () => {
            await sleep(50);

            if (this.isNew)
                this.headerTitle = this.translateService.instant('label.user_new');

            this.msgPrefix = this.translateService.instant('label.user_details') + ' - ';
            const lab0 = this.translateService.instant('label.home') + ' ';
            const lab1 = ' ' + this.translateService.instant('label.Users');
            const lab2 = ' ' + this.translateService.instant('label.UserNew');

            this.BREAD_CRUMB_LIST = [
                { label: lab0, routerLink: '/', selected: false },
                { label: lab1, routerLink: '/user', selected: false },
                { label: lab1, routerLink: '/user/new', selected: true }
            ]

        })();




    }

    // fileChangeEvent(event: any): void {

    //   //  console.log("fileChangeEvent");
    //     this.userPicDialog = true;
    //     this.imageChangedEvent = event;

    //     // this.tipoFoto = 'png';

    //     // if (event.target.files && event.target.files[0]) {
    //     // let file =  event.target.files[0]
    //     // if ((file.name.includes('jpg')) || (file.name.includes('jpeg')))
    //     //     this.tipoFoto = 'jpeg';

    //     // //    console.log(file);

    //     //     var selectedFile = event.target.files[0];



    //         //this.fileList.push(selectedFile);


    //     // var reader = new FileReader();
    //     // reader.readAsDataURL(event.target.files[0]); // read file as data url
    //     // }


    // }

    // imageCropped(event: ImageCroppedEvent) {
    //     //  console.log('Cropped Image Event:', event);
    //     this.croppedImage = event.base64;
    //     this.fileList.push(this.croppedImage);

    //     this.imageBlob = event.blob;
    //     this.imageUrl = event.objectUrl;
    //     this.fileList = [];

    //     fetch(this.imageUrl)
    //         .then((res) => res.blob())
    //         .then((myBlob) => {
    //             const myFile = new File([myBlob], 'image.png', {type: myBlob.type});
    //             this.fileList.push(myFile);
    //         });
    // }

    // imageLoaded() {
    //     this.showCropper = true;
    //     // console.log('cropper load');
    // }
    // cropperReady() {
    //     // cropper ready
    //     // console.log('cropper ready');
    // }
    // loadImageFailed() {
    //     // show message
    //     // console.log('cload fail');
    // }

    // hidePicDialog(): void {
    //     this.userPicDialog = false;
    // }



    // savePic()
    // {
    //     if (this.item.id) {
    //         this.userService.uploadItem(this.fileList, this.item.id)
    //         .subscribe(
    //             {
    //                 next: () =>
    //                 {
    //                     this.item.pictureUri = this.imageUrl;
    //                     this.hasPicture = true;
    //                     this.userPicDialog = false;
    //                     this.notificationsService.toastNotify('success', this.translateService.instant('title.success'), this.translateService.instant('message.picture_updated'));
    //                 },
    //                 error: (err) => {
    //                     this.notificationsService.toastNotify('warn', this.translateService.instant('title.warning'), this.errorMessage);
    //                     console.log(`UsuarioGrid - uploadItem`)
    //                     console.log(err)
    //                 }
    //             });
    //     }
    //     else {
    //         this.item.pictureUri = this.imageUrl;
    //         this.hasPicture = true;
    //         this.userPicDialog = false;
    //     }
    // }

    // cancel()
    // {
    //     this.confirmationService.confirm({
    //         message: this.translateService.instant('message.confirm_cancel'),
    //         header: this.translateService.instant('title.confirmation'),
    //         acceptLabel: this.translateService.instant('button.yes'),
    //         rejectLabel: this.translateService.instant('button.no'),
    //         acceptButtonStyleClass: 'p-button-success',
    //         rejectButtonStyleClass: 'p-button-danger',
    //         icon: 'pi pi-exclamation-triangle',
    //         accept: () => {
    //             this.getItem();
    //         }
    //     });
    // }

    // close()
    // {
    //     this.getItem();
    //     this.router.navigate(['user']);
    // }



    checkEmail(email: string) {


    }

    checkLogin(login: string) {


    }

    onGoBack(): void {
        this.router.navigate(['/user']);
    }

    isFieldValid(field: string) {
        let isValid = true;
        if (field == 'login' && !this.item.login) {
            isValid = true; // If login is empty, consider it invalid
        } else if (field == 'roleId' && !this.item.scRoleId) {
            isValid = true; // If email is empty, consider it invalid
        } else if (field == 'email' && !this.item.email) {
            isValid = true; // If email is empty, consider it invalid
        } else if (field == 'phone' && !this.item.phone) {
            isValid = true; // If phone is empty, consider it invalid
        } else if (field == 'name' && !this.item.name) {
            isValid = true; // If name is empty, consider it invalid
        } else if (field == 'all' && (!this.item.login || !this.item.scRoleId || !this.item.email || !this.item.phone || !this.item.name)) {
            isValid = true; // If any field is empty, consider it invalid
            this.userService.isUserFormValid.emit(isValid);
        } else {
            isValid = false; // If the field has a value, consider it valid
        }

        return isValid;
    }

    onShowPwdUpdate() {
        this.dialogPwdUpdate = true;
        this.passwordForm = this.fb.group(
            {
                password: ['', [Validators.required, Validators.minLength(3)]],
                confirmPassword: ['', [Validators.required, Validators.minLength(3)]],
            },
            { validators: passwordMatchValidator() }
        );
    }

    savePwdUpdate() {
        if (this.passwordForm.valid) {
            this.item.password = this.passwordForm.value.password;
            this.userService
                .updItem(this.item, null, this.userId, this.language)
                .subscribe({
                    next: () => {
                        this.dialogPwdUpdate = false;
                        this.notificationsService.toastNotify('success', this.translateService.instant('title.success'), this.translateService.instant('label.pwd_updated'));
                    },
                    error: (err) => {
                        console.error(`Erro ao atualizar senha: ${err}`);
                        this.notificationsService.toastNotify('error', this.translateService.instant('title.warning'), this.translateService.instant('label.change_pwd_error'));
                    }
                });
            //console.log('Formulário válido:', this.passwordForm.value);
        } else {
            this.notificationsService.toastNotify('error', this.translateService.instant('title.warning'), 'Dados inválidos.');
        }
    }

    cancelPwdUpdate() {
        this.dialogPwdUpdate = false;
    }

    cancelUserUpdate() {
        if (this.isMyData) {
            this.id = this.item.id;
            if (this.isAdmin) {
                this.getItem();
            } else {
                this.item = { ...this.itemTemp };
            }
        } else {
            this.onGoBack();
        }
    }
}
